import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useApiClient } from "../../contexts/ApiClientContext";
import { IApiClientError } from "../../shared/ApiClient";
import { useAlerts } from "../../contexts/AlertsContext";
import AlertMessageType from "../common/alert_message/AlertMessageType";
import Loading from "../common/Loading";
import SETTINGS from "../../globals";
import Button from "../common/button/Button";
import ButtonAction from "../common/button/ButtonAction";
import ButtonType from "../common/button/ButtonType";
import APIEndPoints from "../../utils/APIEndPoints";
import AppSections from "../../utils/AppSections";
import Material from "../../model/Material";

interface IMaterialsListAddElementProps {
  canEdit: boolean;
  navigable: boolean;
  onFormAdded: () => void;
}

function MaterialsListAddElement({
  canEdit,
  navigable,
  onFormAdded,
}: IMaterialsListAddElementProps) {
  const navigate = useNavigate();
  const apiClient = useApiClient();
  const alertsManager = useAlerts();

  // Local state for the editable name
  const [name, setName] = useState("");
  // set state for form info
  const [formData, setFormData] = useState<Material>(Material.EmptyInstance());
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(false);
  }, [apiClient]);

  if (loading) {
    return <Loading />;
  }

  // Handle saving the updated name
  const handleBlurOrEnter = (e?: React.KeyboardEvent<HTMLInputElement>) => {
    if (!e || e.key === "Enter") {
      var body = new Material(formData.name);

      apiClient
        ?.post({ url: APIEndPoints.MATERIALS.NEW, body: body })
        .then((response) => {
          alertsManager.showAlertMessage({
            type: AlertMessageType.SUCCESS,
            message: "Material record created successfully",
          });
          onFormAdded(); // Call the refresh function after successful creation
          setFormData(Material.EmptyInstance()); // Reset the form
        })
        .catch((error: IApiClientError) => {
          console.log(error);
        });
      navigate(SETTINGS.get_path({ section: AppSections.MATERIALS }));
      console.log("Created Material:", name); // You can add API call to save it here
    }
  };

  const handleNameChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ): void => {
    setFormData((prevData) => ({
      ...prevData,
      name: event.target.value,
    }));
  };

  return (
    <div className="p-4 w-full border border-solid border-gray-400 rounded-xl mt-3 mb-5 text-gray-600 hover:bg-blue-50 cursor-pointer details-section">
      <div className="flex flex-col flex-wrap">
        <div className="flex flex-col flex-wrap items-start">
          <div className="flex flex-row justify-between w-full mr-0 pr-0">
            {/* Toggle between text and input field */}

            <div className="flex items-center w-3/5">
              {/* <span className="text-xl font-bold mb-2 mt-0">Name: </span> */}
              <input
                type="text"
                value={formData.name}
                onChange={handleNameChange}
                className=" w-full min-w-0 p-2 border border-gray-300 rounded-md"
                autoFocus
              />
            </div>

            <Button
              label="Create"
              purpose={ButtonAction.CREATE}
              type={ButtonType.ICON}
              onClick={handleBlurOrEnter}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default MaterialsListAddElement;
